import { Component, DestroyRef, EventEmitter, Input, Output, inject } from "@angular/core";
import { CoreCommonModule } from "@core/common.module";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { UserService } from "@core/services/auth";

@Component({
  standalone: true,
  imports: [CoreCommonModule],
  selector: "app-student-reset-password",
  templateUrl: "./student-reset-password.html",
  styleUrls: ["./student-reset-password.scss"],
})
export class StudentResetPasswordComponent {
  @Input() checkedResetUsername = "";
  @Output() back = new EventEmitter<void>();

  resetPasswordForm: UntypedFormGroup;
  loading = false;
  resetPasswordError = "";
  resetPasswordSuccess = "";

  private destroyRef = inject(DestroyRef);
  private _formBuilder = inject(UntypedFormBuilder);
  private _userService = inject(UserService);

constructor() {
  this.resetPasswordForm = this._formBuilder.group({
    name: ["", Validators.required],
  });

  this.resetPasswordForm
    .get("name")
    .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(() => {
      if (this.resetPasswordError) {
        this.resetPasswordError = "";
      }
    });
}

  onSubmit(): void {
    if (this.resetPasswordForm.invalid) return;

    this.loading = true;
    this.resetPasswordError = "";
    this.resetPasswordSuccess = "";
    const name = this.resetPasswordForm.get("name").value;

    this._userService
      .resetPasswordByUsernameAndName(this.checkedResetUsername, name)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.resetPasswordSuccess = res.message;
          this.loading = false;
        },
        error: (err) => {
          this.resetPasswordError = err.error?.message || "An error occurred";
          this.loading = false;
        },
      });
  }

  onBack(): void {
    this.back.emit();
  }
}